var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('foot')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('embed',{attrs:{"src":"https://maipdf.cn/file/at6892ecdf2ce15/pdf","type":"application/pdf","width":"100%","height":"800px"}})])
}]

export { render, staticRenderFns }